import { gql } from '@apollo/client';

export const getAdhesionComercios = gql`
query AdhesionComerciosApi{
    adhesionComercios(id:$id)  
    @rest(type: "adhesionComercio", path: "/api/gateway/formulariosComercios/presolicitud/{args.id}"){
        cuit
        email
        denominacion
        domicilioLegal
        sucursal
        ubicom
        tipoPersona
        esCliente
        error
        estado   
    }
}
`   